setTimeout(() => {
    DyeforImageHotspotManager.init(1);    
}, 500);


class DyeforImageHotspotManager{
    static fi = null;
    static observingItems = [];
    static init(enableRo){
        DyeforImageHotspotManager.fi = DyeforImageHotspotManager.fi|| new DyeforImageHotspotManager();
        DyeforImageHotspotManager.fi.initSmiffysHotspots(enableRo);
    }
    initSmiffysHotspots(enableRo) {
        if (document) {
            let hotSpotImageWraps =  document.querySelectorAll('div.hotspot-image-wrap');
            let ro = new ResizeObserver(entries => {
                for (let entry of entries) {
                    this.updateHotspotPosition(entry.target);  
                }
              });
            for (const hsiw of hotSpotImageWraps) {
                this.updateHotspotPosition(hsiw);
                this.bindImageLinkedHotspotEvents(hsiw);
                this.bindHotspotLinkEvents(hsiw)
                if(enableRo && !DyeforImageHotspotManager.observingItems.includes(hsiw)){
                    ro.observe(hsiw);
                    DyeforImageHotspotManager.observingItems.push(hsiw);
                }
            }            
        }
    }

    bindHotspotLinkEvents(hsiw){
        let imageHotspotLinks = hsiw.querySelectorAll('.image-hotspot_link');
        for(const imageHotspotLink of imageHotspotLinks){
            imageHotspotLink.addEventListener('click', (event)=> event.stopImmediatePropagation());
        }
    }
    bindImageLinkedHotspotEvents(hsiw){
        let imageLinkedHotspots = hsiw.querySelector('dyefor-image-hotspots .image-hotspots[data-href]');
        if(!imageLinkedHotspots){
            return false;
        }

        let link = imageLinkedHotspots.getAttribute('data-href');
        if(link){
            imageLinkedHotspots.addEventListener('click', (event)=> {
                event.preventDefault();
                event.stopImmediatePropagation();
                document.location = link;
            })            
        }
    }
    updateHotspotPosition(hsiw){        

        let imageHotSpots = hsiw.querySelector('dyefor-image-hotspots .image-hotspots');
        if(!imageHotSpots){
            return false;
        }
        let img = hsiw.querySelector('.hotspot-image-wrap img');
        if (img) {
            let nh = img.naturalHeight;
            let nw = img.naturalWidth;
            let nar = nh / nw;

            let h = img.height;
            let w = img.width;
            let ar = h / w;

            
            if (nar > ar) {
                imageHotSpots.style.width = `${w}px`;
                imageHotSpots.style.height = `${nar * w}px`;
                imageHotSpots.style.transform = `translate(0px, -${(nar * w - h) / 2}px)`;
            } else if (nar < ar) {
                imageHotSpots.style.width = `${h / nar}px`;
                imageHotSpots.style.height = `${h}px`;
                imageHotSpots.style.transform = `translate(-${(h / nar - w) / 2}px, 0px)`;
            } else {
                imageHotSpots.style.width = `${w}px`;
                imageHotSpots.style.height = `${h}px`;
            }

            let sihs = hsiw.querySelector('dyefor-image-hotspots');
            if (sihs) {
                sihs.classList.add('active');
                return true;
            }
        }
    }
}